/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.human-resources.supervisors'},
});

const SupervisorsItem = () => (
  <RouteLinkItem
    route="midas/settings/human-resources/supervisors"
    title={messages.title}
  />
);

export default SupervisorsItem;
